"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$column = exports.$columns = exports.$periodSentences = exports.$sentencesArray = exports.forceSentencesArrayToSentenceChildren = exports.sentencesArrayToString = void 0;
const std_1 = require("../../../law/std");
const controls_1 = require("../../../node/el/controls");
const factory_1 = require("../factory");
const _sentenceChildren_1 = __importStar(require("./$sentenceChildren"));
const lexical_1 = require("./lexical");
const util_1 = require("../util");
const inline_1 = require("../../../node/cst/inline");
const std = __importStar(require("../../../law/std"));
const _squareAttr_1 = __importDefault(require("./$squareAttr"));
const sentencesArrayToString = (sentencesArray, options) => {
    const runs = [];
    const { withoutAttrs, escapeLeadingSpaces, } = {
        withoutAttrs: false,
        escapeLeadingSpaces: false,
        ...options,
    };
    for (const sentences of sentencesArray) {
        runs.push(sentences.leadingSpace);
        if (!withoutAttrs) {
            for (const attrEntry of sentences.attrEntries) {
                if (std.defaultAttrs.Sentence[attrEntry.entry[0]] === attrEntry.entry[1])
                    continue;
                runs.push(attrEntry.entryText + attrEntry.trailingSpace);
            }
        }
        for (const sentence of sentences.sentences) {
            runs.push((0, _sentenceChildren_1.sentenceChildrenToString)(sentence.children));
        }
    }
    // eslint-disable-next-line no-irregular-whitespace
    const trailingSpacesEscaped = runs.join("").replace(/[ 　\t]+$/g, s => Array.from(s).map(c => `&#x${c.codePointAt(0)?.toString(16)};`).join(""));
    if (escapeLeadingSpaces) {
        // eslint-disable-next-line no-irregular-whitespace
        return trailingSpacesEscaped.replace(/^[ 　\t]+/g, s => Array.from(s).map(c => `&#x${c.codePointAt(0)?.toString(16)};`).join(""));
    }
    else {
        return trailingSpacesEscaped;
    }
};
exports.sentencesArrayToString = sentencesArrayToString;
const forceSentencesArrayToSentenceChildren = (sentencesArray) => {
    return (0, util_1.mergeAdjacentTexts)(sentencesArray
        .map(sentences => [
        ...((sentences.leadingSpace !== "")
            ? [new controls_1.__Text(sentences.leadingSpace, sentences.leadingSpaceRange)]
            : []),
        ...sentences.sentences.map(s => s.children).flat(),
    ])
        .flat());
};
exports.forceSentencesArrayToSentenceChildren = forceSentencesArrayToSentenceChildren;
exports.$sentencesArray = factory_1.factory
    .withName("sentencesArray")
    .choice(c => c
    .or(() => exports.$columns)
    .orSequence(c => c
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(() => _squareAttr_1.default, "entry")
    .and(() => lexical_1.$_, "trailingSpace")
    .action(({ entry, trailingSpace, range }) => {
    const r = range();
    entry.value.trailingSpace = trailingSpace;
    if (entry.value.entryRange) {
        entry.value.trailingSpaceRange = [
            entry.value.entryRange[1],
            r[1],
        ];
    }
    return {
        value: entry.value,
        errors: entry.errors,
    };
}))), "attrEntries")
    .and(r => r
    .choice(c => c
    .or(() => exports.$periodSentences)
    .orSequence(s => s
    .and(() => _sentenceChildren_1.default, "inline")
    .action(({ inline, range }) => {
    return {
        value: [
            (0, std_1.newStdEL)("Sentence", {}, inline.value, range())
        ],
        errors: inline.errors,
    };
}))), "sentences")
    .action(({ attrEntries, sentences, range }) => {
    const r = range();
    const errors = [
        ...attrEntries.map(e => e.errors).flat(),
        ...sentences.errors,
    ];
    return {
        value: [
            new inline_1.Sentences("", [r[0], r[0]], attrEntries.map(e => e.value).flat(), sentences.value)
        ],
        errors,
    };
})));
exports.default = exports.$sentencesArray;
exports.$periodSentences = factory_1.factory
    .withName("periodSentences")
    .sequence(c => c
    .and(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .and(() => _sentenceChildren_1.$PERIOD_SENTENCE_FRAGMENT, "value")
    .action(({ value, range }) => ({ value, range: range() })))), "fragments")
    .action(({ fragments }) => {
    const sentences = [];
    const errors = [];
    const proviso_indices = [];
    for (let i = 0; i < fragments.length; i++) {
        const sentence_content = fragments[i].value.value;
        errors.push(...fragments[i].value.errors);
        const sentence = (0, std_1.newStdEL)("Sentence", {}, sentence_content, fragments[i].range);
        if (fragments.length >= 2)
            sentence.attr.Num = String(i + 1);
        if (sentence_content[0] instanceof controls_1.__Text &&
            sentence_content[0].text().match(/^ただし、|但し、/)) {
            proviso_indices.push(i);
        }
        sentences.push(sentence);
    }
    if (proviso_indices.length > 0) {
        for (let i = 0; i < sentences.length; i++) {
            sentences[i].attr.Function =
                proviso_indices.indexOf(i) >= 0 ?
                    "proviso" : "main";
        }
    }
    return { value: sentences, errors };
}));
exports.$columns = factory_1.factory
    .withName("columns")
    .sequence(c => c
    .and(() => exports.$column, "firstColumn")
    .and(r => r
    .oneOrMore(r => r
    .sequence(c => c
    .and(r => r
    .sequence(s => s
    .and(() => lexical_1.$__, "value")
    .action(({ value, range }) => ({ value, range: range() }))), "leadingSpace")
    .and(() => exports.$column, "column")
    .action(({ leadingSpace, column }) => {
    column.value.leadingSpace = leadingSpace.value;
    column.value.leadingSpaceRange = leadingSpace.range;
    return {
        value: column.value,
        errors: column.errors,
    };
}))), "restColumns")
    .action(({ firstColumn, restColumns }) => {
    const columns = [firstColumn, ...restColumns];
    return {
        value: columns.map(c => c.value),
        errors: columns.map(c => c.errors).flat(),
    };
}));
exports.$column = factory_1.factory
    .withName("column")
    .sequence(c => c
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(() => _squareAttr_1.default, "entry")
    .and(() => lexical_1.$_, "trailingSpace")
    .action(({ entry, trailingSpace }) => {
    return {
        value: {
            ...entry.value,
            trailingSpace
        },
        errors: entry.errors,
    };
}))), "attrEntries")
    .and(() => exports.$periodSentences, "sentences")
    .action(({ attrEntries, sentences, range }) => {
    const r = range();
    const errors = [
        ...attrEntries.map(e => e.errors).flat(),
        ...sentences.errors,
    ];
    return {
        value: new inline_1.Sentences("", [r[0], r[0]], attrEntries.map(e => e.value).flat(), sentences.value),
        errors,
    };
}));
//# sourceMappingURL=$sentencesArray.js.map